package pwgs.ui.scenes.leaderboardlistscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.components.page.Page
import visage.ds.utils.EHAlign

class MLeaderboardListScene(props: LeaderboardListSceneProps) : AScene<LeaderboardListSceneProps, LeaderboardListSceneModel, LeaderboardListSceneState, LeaderboardListControllerFe>(props) {

    override fun createController() : LeaderboardListControllerFe {
        return LeaderboardListControllerFe(props, this)
    }

    override fun initState() : LeaderboardListSceneState {
        return LeaderboardListSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MLeaderboardListScene.model
        val c = this@MLeaderboardListScene.controller
        Page {
            isLoading = m.isLoading

            head("Leaderboards")

            body {
                Card {
                    header("Leaderboards") {
                        ResponsiveButtonWithIcon(
                            "add",
                            "Create new leaderboard",
                            EButtonColor.Success,
                            c::onCreateLeaderboardButtonClicked)
                    }

                    body {
                        Table {
                            columns {
                                fixedColumn("Name")
                                fixedColumn("Field")
                                fixedColumn("Editable")
                                fixedColumn("Order")
                                fixedColumn("", hAlign = EHAlign.Right)
                            }

                            body {
                                m.leaderboards.forEach {
                                    row {
                                        cell(it.name)
                                        cell(it.linkedField)
                                        cell(if (it.clientChangeable) "Yes" else "No")
                                        cell(if (it.sortOrder == ESortOrder.Asc) "Asc" else "Desc")
                                        cell {
                                            IconButton("delete") {
                                                size = EButtonSize.Small
                                                variant = EButtonVariant.Link
                                                color = EButtonColor.Danger
                                                onClick = { c.onDeleteLeaderboardClicked(it.name)}
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (m.createLeaderboardDialogModel != null) {
            val dm = m.createLeaderboardDialogModel!!
            Modal("Create leaderboard...") {
                isLoading = dm.isLoading
                error = dm.error
                TextField("Name", dm.nameFieldModel) {
                    infoText = "The name of the leaderboard. You wil use this name as the ID to interact with it from code"
                }
                Select("Linked field", dm.linkedFieldModel) {
                    infoText = "The field of the player entity which will used as the score of the leaderboard"
                }
                Select("Sort order", dm.sortOrderField) {
                    infoText = "The sort order of the leaderboard"
                }
                Select("Client changeable", dm.clientChangeableField) {
                    infoText = "Indicates if the value of the linked field can be manipulated by the Leaderboard api from the client"
                }

                footer {
                    Button("Cancel", EButtonColor.Secondary, EButtonVariant.Link, c::onCancelCreate)
                    Button("Submit", EButtonColor.Primary, EButtonVariant.Filled, c::onSubmitCreate)
                }
            }
        }
    }
}

class LeaderboardListSceneState {

}

fun Components.LeaderboardListScene(props: LeaderboardListSceneProps) = this.registerComponent(MLeaderboardListScene(props), {})
